// src/modules/app-views/services/service.js
// *****************************************************************************
// AI SERVICE - Service Cataloging
// *****************************************************************************

import axiosService from 'services/axiosService';
import { API } from 'constants/Api';
import { mergeUrlParamsQuery } from 'utils/urlUtils';

// *****************************************************************************
// CATALOG SERVICES
// *****************************************************************************

/**
 * Cataloga um servico usando IA
 */
export const catalogService = async ({
  serviceDescription,
  price,
  model,
  requestOrigin = 0,
}) => {
  const [doc, result] = await axiosService.post({
    url: API.SERVICES.IA_CATALOG,
    data: {
      serviceDescription,
      price,
      model,
      requestOrigin,
    },
    returnAsObject: true,
    timeout: 300000, // 5 minutes - AI cataloging with retries can take up to ~244s
  });

  return result;
};

// *****************************************************************************
// ADD TO SET (array operations)
// *****************************************************************************

/**
 * Add, update, or remove items from an array field in a service document
 */
export const servicesAddToSet = async ({ _id, operator, path, data }) => {
  const url = mergeUrlParamsQuery({
    url: API.SERVICES.ADD_TO_SET,
    params: { _id, operator, path },
  });

  const [result] = await axiosService.put({
    url,
    data,
    headers: { 'x-resultasobject': true },
  });

  return result;
};

// *****************************************************************************
// PRICES
// *****************************************************************************

/**
 * Get AI model prices for service cataloging
 */
export const getAiPrices = async () => {
  const [docs, result] = await axiosService.get({
    url: API.SERVICES.IA_PRICES,
  });

  return result;
};

// *****************************************************************************
// EXPORT
// *****************************************************************************

export default {
  catalogService,
  servicesAddToSet,
  getAiPrices,
};
